import { render, staticRenderFns } from "./WoundCare.vue?vue&type=template&id=a1a9524c&scoped=true&"
import script from "./WoundCare.vue?vue&type=script&lang=js&"
export * from "./WoundCare.vue?vue&type=script&lang=js&"
import style0 from "./WoundCare.vue?vue&type=style&index=0&id=a1a9524c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a9524c",
  null
  
)

export default component.exports